import { render, staticRenderFns } from "./AddEditContact.vue?vue&type=template&id=86f318ce&"
import script from "./AddEditContact.vue?vue&type=script&lang=js&"
export * from "./AddEditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports